import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTable16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTable16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 3h9c.551 0 1 .448 1 1.001V5H2V4a1 1 0 0 1 1-1m6 3H6v2h3zm0 3H6v2h3zm1 2V9h3v2zm-1 1H6v2h3zm1 2v-2h3v.999c0 .553-.449 1.001-1 1.001zm0 1H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2.001V13a2 2 0 0 1-2 2zm0-7V6h3v2zM2 6h3v2H2zm0 3h3v2H2zm0 3h3v2H3a1 1 0 0 1-1-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTable16);
